/** The date half of a range end. Clicking it aims the calendar at that end. */
import { Calendar, ChevronDown } from 'lucide-react';

import { formatDateKey, type DateKey } from './date-keys';
import { fieldBoxStyle } from './picker-styles';

export interface DateButtonProps {
  label: string;
  value: DateKey;
  active: boolean;
  invalid: boolean;
  onClick: () => void;
}

export function DateButton({ label, value, active, invalid, onClick }: DateButtonProps) {
  return (
    <button
      type="button"
      aria-label={`${label}: ${formatDateKey(value)}`}
      aria-pressed={active}
      onClick={onClick}
      style={{ ...fieldBoxStyle(active, invalid), flex: 1, cursor: 'pointer', textAlign: 'left' }}
    >
      <Calendar size={15} aria-hidden style={{ flex: '0 0 auto', color: 'var(--nb-muted)' }} />
      <span style={{ flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {formatDateKey(value)}
      </span>
      <ChevronDown size={14} aria-hidden style={{ flex: '0 0 auto', color: 'var(--nb-subtle)' }} />
    </button>
  );
}
